import { Address } from 'viem';

export enum SortDestination {
  Asc = 'ASC',
  Desc = 'DESC',
}

export const PERCENT_DIVIDER = 100;

export const WHITE_LIST_ADDRESS = [
  '0xdd035e4a299fAFFe584d459F6d86C23fFBD6D3f0',
  '0xCF345506097f1F67Ee87108491a74c4194489A29',
  '0xc9c5fAb8C795BA16cc523Bbef8030807D1421F98',
  '0x0f1B97170118ae387cF5A29578E68E5D78433813',
];

export const ADMINS_LIST_ADDRESS = [
  '0xdd035e4a299fAFFe584d459F6d86C23fFBD6D3f0',
  '0xCF345506097f1F67Ee87108491a74c4194489A29',
  '0xc9c5fAb8C795BA16cc523Bbef8030807D1421F98',
  '0x0f1B97170118ae387cF5A29578E68E5D78433813',
  '0xBfd8194f7cC17D2f4f324E440F47571D845bcfFF',
  '0x1BD2532843Cc60168cc657cE296C9F2144c62FCe',
] as Address[];
